import { DeleteButton } from '@/components/Elements/Button'
import { InputCell, PriceCell, RawTextCell, TextCell } from '@/components/Table/components/Cell'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { ListStatus } from '@/constants/api.constant'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'

const getGCMaterialTableColumns = ({ handleActivateGCMaterial = () => {}, handleDeleteGCMaterial = () => {} }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 200,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <Flex w="100%" alignItems={'center'}>
            {original?.status === ListStatus.ACTIVE && (
              <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100px">
                <MdDeleteOutline
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDeleteGCMaterial(original._id)
                  }}
                />
              </Flex>
            )}
            {original?.status === ListStatus.INACTIVE && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100px">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleActivateGCMaterial(original._id)
                  }}
                />
              </Flex>
            )}
          </Flex>
        )
      },
    }),

    columnHelper.accessor('SEN', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('articleType', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('unitCost', {
      cell: PriceCell,
      meta: {
        filterVariant: FilterType.RANGE,
      },
    }),
    columnHelper.accessor('unitCostHKD', {
      cell: PriceCell,
      meta: {
        filterVariant: FilterType.RANGE,
      },
    }),
    columnHelper.accessor('currency', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('unit', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('MOQ', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.RANGE,
      },
    }),
    columnHelper.accessor('ECCN', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('ctyOfOrigin', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('description', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('SAPMaterialNumber', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('vendor', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('purchaseScenario', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('CSID', {
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('zuroa', {
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('priceTerm', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('chargeType', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('requiredLicenseManager', {
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('isBuildingX', {
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('isStandAlonePR', {
      header: () => <>Stand Alone PR</>,
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('discontinued', {
      header: () => <>Discontinued</>,
      cell: TextCell,
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
    columnHelper.accessor('status', {
      cell: RawTextCell,
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ],
      },
    }),
  ]
}

export const getGCMaterialDetailTableColumns = ({ handleRemoveRow = () => {} }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 81,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ getValue, row: { original, index }, table, extraDisable = false }) => {
        const value = getValue()
        const isDisabled = table.options.meta?.disabled || extraDisable

        if (isDisabled) {
          return <></>
        }

        return <DeleteButton onClick={() => handleRemoveRow(index)} />
      },
    }),
    columnHelper.accessor('description', {
      size: 300,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('unit', {
      size: 81,
      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('rate', {
      size: 100,

      header: () => <>Rate for Typical floor</>,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_1', {
      header: () => <span>Discount Rate Over 10 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_2', {
      header: () => <span>Discount Rate Over 50 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('discountRate_3', {
      header: () => <span>Discount Rate Over 100 lot</span>,
      size: 81,

      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
    columnHelper.accessor('remark', {
      cell: InputCell,
      meta: {
        filterVariant: FilterType.SIMPLE_TEXT,
      },
    }),
  ]
}

export default getGCMaterialTableColumns
